import { GetStaticPropsContext } from 'next';
import { withPageStaticProps } from 'utils/header';
import { SanityPageProps, withSanityPageProps } from 'components/sanity/withSanityPageProps';
import PageBuilder from 'components/sanity/PageBuilder';
import { getPageSettings, pageByIdQuery } from '@root/server/services/Pages';
import Head from 'next/head';

const getIndexProps = withSanityPageProps(async (_: GetStaticPropsContext) => {
  const pageSettings = await getPageSettings();

  const page = pageSettings.homepage;

  if (!page) {
    throw new Error('Query for homepage did not return all the expected documents');
  }

  return {
    props: {
      data: {
        page,
        query: pageByIdQuery,
        queryParams: {
          id: page._id,
        },
      },
    },
  };
});

export const getStaticProps = withPageStaticProps(getIndexProps);

const Index = (props: SanityPageProps) => (
  <>
    <PageBuilder {...props} />

    <Head>
      <meta property="og:url" key="og:url" content={`${process.env.NEXT_PUBLIC_LOCAL_URL}`} />

      <meta name="twitter:url" key="twitter:url" content={`${process.env.NEXT_PUBLIC_LOCAL_URL}`} />
      <meta name="twitter:site" key="twitter:site" content="@generationtux" />
      <meta name="twitter:card" key="twitter:card" content="summary_large_image" />
    </Head>
  </>
);

export default Index;
